import { ContactsTab } from "../schema/contacts";

/**
 * Resolves the `?tab=` query param to a valid ContactsTab. Case-insensitive so
 * deep links with wrong-cased values (e.g. the extension's old `tab=contacts`
 * links) still land on a working tab; unknown values fall back to CONTACTS.
 */
export const normalizeContactsTab = (raw: string | null): ContactsTab => {
	const upper = raw?.toUpperCase() as ContactsTab | undefined;

	return upper && Object.values(ContactsTab).includes(upper) ? upper : ContactsTab.CONTACTS;
};
